export default __webpack_public_path__ + "static/media/IMG_1058.f3dc2860.jpg";